import { render, staticRenderFns } from "./SummaryChart.vue?vue&type=template&id=f6439d96&scoped=true&"
import script from "./SummaryChart.vue?vue&type=script&lang=js&"
export * from "./SummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6439d96",
  null
  
)

export default component.exports